import path from "path";

const jsOrTsFileSet = new Set([".js", ".ts", ".mjs", ".mts", ".cjs", ".cts"]);

export const isJsOrTsFile = (filePath: string) => {
  return jsOrTsFileSet.has(path.extname(filePath));
};

export const isExecutableJsOrTsFile = (filePath: string) => {
  return isJsOrTsFile(filePath) && !filePath.endsWith(".d.ts");
};

const modelsDir = "api/models/";
const schemaFile = "/schema.gadget.ts";
const numbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

export const schemaFileDirParts = (path: string): string[] | null => {
  if (!path.startsWith(modelsDir) || !path.endsWith(schemaFile)) {
    return null;
  }

  const dirNames = path.slice(modelsDir.length, -schemaFile.length);
  if (dirNames == "") return null;
  return dirNames.split("/");
};

export const fileIsNamespacedModelSchemaMetadata = (file: { path: string }) => {
  const parts = schemaFileDirParts(file.path);
  return Boolean(parts);
};

export const fileIsNonNamespacedModelSchemaMetadata = (file: { path: string }) => {
  const parts = schemaFileDirParts(file.path);
  if (!parts) return false;
  return parts.length == 1 && !numbers.includes(parts[0][0]);
};
